import styled from "styled-components";

export const SettingRootDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const PanelRootDiv = styled.div`
  display: flex;
  overflow: auto;
  flex: 1;
`;

export const PanelDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const LogButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 24px;
`;
